module.exports = __webpack_public_path__ + "static/media/img_29tv02.8c6837d6.jpg";